import { setCookie } from '@/utils/tool'
export default {
  data() {
    return {
      list: ['l_zh_cn', 'l_en_us', 'l_ja_jp', 'l_ko_kr', 'l_zh_tw'],
      currentVal: ''
    }
  },
  methods: {
    handleCommand(command) {
      this.currentVal = command
      // 切换语言
      let lang = command.split('l_')[1]
      lang = lang.toLowerCase().replace('_', '-')
      this.$i18n.locale = lang
      // 记录cookie
      setCookie('_cpl', lang, 365)
      // 记录store
      this.$store.commit('user/saveLanguage', lang)
      // 刷新页面
      // this.$router.go(0)
    }
  },
  computed: {
    currentText() {
      // console.log('text', this.$t(this.currentVal))
      return this.$t(this.currentVal)
    }
  },
  mounted() {
    let locale = this.$i18n.locale || 'en-us'
    locale = locale.toLowerCase().replace('-', '_')
    this.currentVal = `l_${locale}`
    // console.log('this.currentVal', this.currentVal);
  }
}
